import { SectionContentSkeleton, SectionSkeleton, Stack } from '@cmg/design-system';
import React from 'react';

const IndicationComplianceLoadingSkeleton: React.FC = () => {
  return (
    <Stack gap={3}>
      <SectionSkeleton aria-label="Compliance section skeleton">
        <SectionContentSkeleton />
      </SectionSkeleton>
      <SectionSkeleton aria-label="Compliance section skeleton">
        <SectionContentSkeleton />
      </SectionSkeleton>
      <SectionSkeleton aria-label="Compliance section skeleton">
        <SectionContentSkeleton />
      </SectionSkeleton>
    </Stack>
  );
};

export default IndicationComplianceLoadingSkeleton;
